// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2M4Mx","label":"Completed_label__8rKIl"};